import React from "react";
import type { GatsbyBrowser } from "gatsby";
import "./src/pages/normalize.css";
import "sal.js/dist/sal.css";
import "./src/components/layout/layout.scss";
import "./src/pages/index.scss";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
  return element;
};
